import React, { useContext, useEffect, useState } from "react";

import CryptoJS from "crypto-js";
import _ from "lodash";

import FullPageLoader from "../Components/Loader/FullPageLoader";
import { sessionStorageToken } from "../Helper";

const AppContext = React.createContext();

export function useAppContext() {
  return useContext(AppContext);
}

export default function Context({ children }) {
  // const session = useSessionStorage()
  const searchParams = new URLSearchParams(window.location.search);

  const [session, setSession] = useState({
    isLoading: true,
    isWebView: !!searchParams.get('is_webView') || false,
    isSocketConnected: false,
    user: {},
    selectedQuiz: {},
  });

  useEffect(() => {

    if (searchParams.get('is_webView') || !!sessionStorage.getItem('is_webView')) {
      sessionStorage.setItem('is_webView', 1)
      window.authorizeUser = (data = {}) => {
        const user = JSON.parse(data)
        setSession((prev) => {
          return {
            ...prev,
            isLoading: false,
            isWebView: true,
            user: user
          };
        })
      };

      if (window?.FlutterChannel) {
        window.FlutterChannel.postMessage("authorize");
      }
      else {
      }
      return
    }

    sessionStorage.removeItem('is_webView')
    const token = sessionStorage.getItem(sessionStorageToken());
    if (token) {
      const decrypted = CryptoJS.AES.decrypt(
        token,
        process.env.REACT_APP_SECRET_KEY
      );
      const data = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
      setSession((prev) => {
        return {
          isLoading: false,
          user: data,
        };
      });
    } else {
      const user = [
        {
          "id": 2,
          "slug": "a5601ad8-3ec6-4880-b90f-e0bf3cbabee5",
          "name": "Delbert Schinner",
          "email": "test1@yopmail.com",
          "image_url": "https://api.famdna.com/user-placeholder.jpeg",
          "mobile_no": "517-207-3625",
          "api_token": "ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SjFjMlZ5WDJsa0lqb3lMQ0pwWVhRaU9qRTNOekU0TnpNMk5UY3NJbVY0Y0NJNk1UZ3dNelF3T1RZMU55d2lhWE56SWpvaU9EYzNabVpsTWpVdE9HVTJOUzAwTkRreExUazFOV1V0WXpkaU1ESXdNemN6TXpJeElpd2ljM1ZpSWpvaU9EYzNabVpsTWpVdE9HVTJOUzAwTkRreExUazFOV1V0WXpkaU1ESXdNemN6TXpJeElpd2lhblJwSWpvaWRYTmxjaTB5SW4wLkhuTk9ZeDVPeS1yOUg4YlpOWlFoZGhoQWUwakNzZV9za0lWZDlLbXN4UFU=",
        },
        {
          "id": 3,
          "slug": "ae22d7a3-e691-48ef-8cb6-593c4805962e",
          "name": "Earnest Dooley",
          "email": "test2@yopmail.com",
          "image_url": "https://api.famdna.com/user-placeholder.jpeg",
          "mobile_no": "899-606-2599",
          "api_token": "ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SjFjMlZ5WDJsa0lqb3pMQ0pwWVhRaU9qRTNOekU0TnpNM01UWXNJbVY0Y0NJNk1UZ3dNelF3T1RjeE5pd2lhWE56SWpvaU9EYzNabVpsTWpVdE9HVTJOUzAwTkRreExUazFOV1V0WXpkaU1ESXdNemN6TXpJeElpd2ljM1ZpSWpvaU9EYzNabVpsTWpVdE9HVTJOUzAwTkRreExUazFOV1V0WXpkaU1ESXdNemN6TXpJeElpd2lhblJwSWpvaWRYTmxjaTB6SW4wLmRrOWhoSXhXMVVpX21fVXdGYTMwdmxxYlZtS2VRM25FYkE0cVA1MXlZQ28="
        },
        {
          "id": 4,
          "slug": "a3a15703-2551-4e99-902e-19093e6fb3ef",
          "name": "Ms. Helen Cummerata",
          "email": "test3@yopmail.com",
          "image_url": "https://api.famdna.com/user-placeholder.jpeg",
          "mobile_no": "661-523-8509",
          "api_token": "ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SjFjMlZ5WDJsa0lqbzBMQ0pwWVhRaU9qRTNOVFU0TmpjNE5qTXNJbVY0Y0NJNk1UYzROelF3TXpnMk15d2lhWE56SWpvaU9EYzNabVpsTWpVdE9HVTJOUzAwTkRreExUazFOV1V0WXpkaU1ESXdNemN6TXpJeElpd2ljM1ZpSWpvaU9EYzNabVpsTWpVdE9HVTJOUzAwTkRreExUazFOV1V0WXpkaU1ESXdNemN6TXpJeElpd2lhblJwSWpvaWRYTmxjaTAwSW4wLm5ld3NjemZ4bDVYR1RDSERGWHhjeklGdE95T2FGTDA4NGlodWljU01VdmM="
        }
      ]

      setSession((prev) => {
        return {
          isLoading: false,
          user: user[(parseInt(searchParams.get('user')) - 1) || 0]
        };
      });
    }

    return () => {
      sessionStorage.removeItem('is_webView')
    }
  }, []);

  const updateUser = (data = {}) => {
    sessionStorage.setItem(
      sessionStorageToken(),
      CryptoJS.AES.encrypt(
        JSON.stringify(data),
        process.env.REACT_APP_SECRET_KEY
      )
    );
    setSession((prev) => {
      return {
        ...prev,
        user: data,
      };
    });
  };

  const logout = (data = {}) => {
    sessionStorage.removeItem(sessionStorageToken());
    setSession((prev) => {
      return {
        ...prev,
        user: {},
      };
    });
  };

  const updateSocketStatus = (status) => {
    setSession((prev) => {
      return {
        ...prev,
        isSocketConnected: status,
      };
    });
  };

  const SelectQuiz = (quiz) => {
    setSession((prev) => {
      return {
        ...prev,
        selectedQuiz: quiz,
      };
    });
  };

  return (
    <AppContext.Provider
      value={{
        isLoggedIn: !_.isEmpty(session?.user),
        isWebView: session.isWebView,
        isSocketConnected: !!session.isSocketConnected,
        updateSocketStatus,
        user: session?.user,
        updateUser,
        SelectQuiz,
        selectedQuiz: session.selectedQuiz,
        logout,
      }}
    >
      {session?.isLoading ? <FullPageLoader /> : children}
    </AppContext.Provider>
  );
}
